export default __webpack_public_path__ + "static/media/white-bag-inactive@3x.dd6b69a9.png";